import { ImgHTMLAttributes } from "react";

const DocusignIcon = (props: React.DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) => {
  return <img src="https://assets-global.website-files.com/633c59f8e08675a520e9f0ae/6345a42c2a73234ee04669dd_sig-icon.svg" {...props} />;
};

export default DocusignIcon;
